export default "__VITE_ASSET__C2_kZtxx__"